/**
 * Import Dependency
 */
import { handleActions } from 'redux-actions'
import update from 'immutability-helper'
import menu from '../../services/api/menu'

/**
 * Declare Variable
 */
const defaultMenusCacheState = {
  forceRefreshMenu: false,
}
const defaultCommodities = []

/**
 * Export
 */
export const menusCache = handleActions({
  GET_MENUS: (state, action) => {
    const payload = action.payload
    if (!payload) return state
    const key = menu.getListKey(payload.categoryId, payload.tag)
    return update(state, {
      [key]: {
        $set: payload.menus,
      },
    })
  },
  RESET_MENUSCACHE: (state, action) => {
    return defaultMenusCacheState
  },
  UPDATE_FORCE_REFRESH_MENU: (state, action) => {
    return update(state, {
      forceRefreshMenu: {
        $set: action.payload,
      },
    })
  },
}, defaultMenusCacheState)

export const commodities = handleActions({
  GET_COMMODITIES: (state, action) => {
    return action.payload.commodities
  },
}, defaultCommodities)

export default {
  menusCache,
  commodities, // > for combine reducer
}



// WEBPACK FOOTER //
// ./src/reducers/components/menu.js